import Slider from "react-slick";
import { useAppDispatch } from "../redux/store/hooks";
import { cardData } from "../scripts/products";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useRef, useState } from "react";
import { Button, Image } from "antd";

function Product() {
  const dispatch = useAppDispatch();
  const current = +window.location.pathname.split("/")[2];
  let products = cardData;
  let product = products[current];
  const [nav1, setNav1] = useState<any>(null);
  const [nav2, setNav2] = useState<any>(null);
  let sliderRef1: any = useRef(null);
  let sliderRef2: any = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  return (
    <div className="App">
      <h2>Каталог продуктов </h2>
      <div className="white-block">
        <div className="flex-start">
          <div className="flex_mobile">
            {product?.images.length > 1 && (
              <div className="slider2">
                <Slider
                  asNavFor={nav1}
                  ref={(slider) => (sliderRef2 = slider)}
                  slidesToShow={4}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  vertical={true}
                  verticalSwiping={true}
                  infinite={false}
                  arrows={product?.images.length > 3}
                >
                  {product?.images.map((img, i) => (
                    <div>
                      <img
                        src={img}
                        alt={product?.title}
                        key={i}
                        className="point-image"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            )}

            <div className="slider1">
              {product?.images.length > 1 ? (
                <Slider asNavFor={nav2} ref={(slider) => (sliderRef1 = slider)}>
                  {product?.images.map((img, i) => (
                    <div>
                      <Image.PreviewGroup items={product?.images}>
                        <Image
                          src={img}
                          alt={product?.title}
                          key={i}
                          className="slider-image"
                        />
                      </Image.PreviewGroup>
                    </div>
                  ))}
                </Slider>
              ) : (
                <Image
                  src={product?.images[0]}
                  alt={product?.title}
                  className="slider-image"
                ></Image>
              )}
            </div>
          </div>
          <div className="product">
            <div className="flex-end">
              <p className="title-small">{product?.title}</p>
              <div className="card">
                <p className="title-small">
                  {product?.price?.toLocaleString("ru-RU")} ₽
                </p>
                <span className="prop_title">
                  {product?.price?.toLocaleString("ru-RU")} ₽ за 1 шт без учета
                  доставки
                </span>
                <Button type="primary">Связаться с продавцом</Button>
              </div>
            </div>
            <div id="section-characteristics">
              <div>
                {product?.properties && (
                  <p className="block-title" style={{ width: "100%" }}>
                    Характеристики
                  </p>
                )}
                <div className="flex">
                  <div className="half-width">
                    {product?.properties?.kind && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">Вид воды</span>
                        </div>
                        <div className="prop_value">
                          <div>{product?.properties?.kind}</div>
                        </div>
                      </div>
                    )}
                    {product?.properties?.gas && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">Газирование</span>
                        </div>
                        <div className="prop_value">
                          <div>{product?.properties?.gas}</div>
                        </div>
                      </div>
                    )}
                    {product?.properties?.water_source && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">
                            Природный источник воды
                          </span>
                        </div>
                        <div className="prop_value">
                          <div>{product?.properties?.water_source}</div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="half-width">
                    {product?.properties?.value && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">Объем, мл</span>
                        </div>
                        <div className="prop_value">
                          <div>
                            {(+product?.properties?.value)?.toLocaleString(
                              "ru-RU"
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {product?.properties?.pack && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">Упаковка</span>
                        </div>
                        <div className="prop_value">
                          <div>{product?.properties?.pack}</div>
                        </div>
                      </div>
                    )}
                    {product?.properties?.unit && (
                      <div className="prop_all">
                        <div className="prop">
                          <span className="prop_title">
                            Единиц товара
                          </span>
                        </div>
                        <div className="prop_value">
                          {(+product?.properties?.unit)?.toLocaleString(
                            "ru-RU"
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex">
                  <div className="half-width">
                    <div className="prop_all">
                      <div className="prop">
                        <span className="prop_title">Артикул</span>
                      </div>
                      <div className="prop_value">
                        <span className="">
                          <span className="">{product?.id}</span>
                        </span>
                      </div>
                    </div>
                    <div className="prop_all">
                      <div className="prop">
                        <span className="prop_title">Тип</span>
                      </div>
                      <div className="prop_value">{product?.type}</div>
                    </div>
                  </div>
                  <div className="half-width">
                    <div className="prop_all">
                      <div className="prop">
                        <span className="prop_title">Производитель</span>
                      </div>
                      <div className="prop_value">
                        <div>{product?.seller}</div>
                      </div>
                    </div>
                    <div className="prop_all">
                      <div className="prop">
                        <span className="prop_title">Страна-изготовитель</span>
                      </div>
                      <div className="prop_value">
                        <div>Россия</div>
                      </div>
                    </div>
                  </div>
                </div>
                {product?.properties?.consist && (
                  <div className="prop_all">
                    <div className="">
                      <span className="prop_title">Состав</span>
                    </div>
                    <div className="prop_desc">
                      {product?.properties?.consist}
                    </div>
                  </div>
                )}
                <div className="prop_all">
                  <div className="">
                    <span className="prop_title">Описание</span>
                  </div>
                  <div className="prop_desc">{product?.description}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
